<template>
  <footer class="footer app-footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            All rights reserved,
            <a href="https://edpartnersafrica.com/" class="font-weight-bold" target="_blank"
              >Ed Partners Africa Ltd.</a>
          </div>
        </div>
        <div class="col-lg-6">

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
